
import { defineComponent, ref, watch, onMounted, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import MusicComponent from '@/components/Music.vue'
import DialogComponent from '@/components/Dialog.vue'

import Moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    name: 'App',
    components: {
        MusicComponent,
        DialogComponent
    },
    computed: {
        ...mapState(['activityData', 'dialogData'])
    },
    setup (props, context) {
        const $store = useStore()
        const router = useRouter()
        const _this = getCurrentInstance() as any
        const isApp = ref<boolean>(false)
        const musicUrl = ref<string>('')

        const getActDetail = () => {
            _this.proxy.$request('/activity/config', {
                aid: $store.state.aid
            }).then((data: any) => {
                // 设置分享信息
                data.share && setShareData(data)
                if (data && data.music && data.music.musicUrl) {
                    musicUrl.value = data.music.musicUrl
                }  
                loadImgs(data)
            })
        }

        const activityStatus = (data: any) => {
            if (new Date(data.serverTime).getTime() < new Date(data.startTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: `活动尚未开启，请在${Moment(data.startTime).format('YYYY.MM.DD')}-${Moment(data.endTime).format('YYYY.MM.DD')}时间段内来参与！`
                })
            } else if (new Date(data.serverTime).getTime() > new Date(data.endTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: '您来晚了，本活动已经结束！'
                })
            } else if (!isApp.value && data.isAppShow) {
                $store.commit('SET_DIALOGDATA', {
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
            }
        }

        const setShareData = (data: any) => {
            $store.commit('SET_SHAREDATA', {
                title: data.share.title,
                desc: data.share.desc,
                imgUrl: data.share.imgUrl || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                link: window.location.href.split('#')[0]
            })
        }

        const loadImgs = (data: any) => {
            const imgs = ["answer_bg.jpg","answer_correct_icon.png","answer_delete_btn.png","answer_error_icon.png","answer_skip_btn.png","answer_submit_btn.png","home_bg.jpg","home_bg_leaf.png","home_bg_left.png","home_bg_right.png","home_bg_top.png","home_btn.png","home_rule_btn.png","home_sub_title.png","home_title.png","music_btn.png","result_again_btn.png","result_bg.jpg","result_close_btn.png","result_msg_btn.png","result_share_btn.png","result_submit_btn.png","result_title.png","rule_close.png","rule_title.png","share_bg.jpg"]
            let index = 0
            let len = imgs.length
            for(let img of imgs) {
                _this.proxy.$common.onloadImg(require(`@/assets/img/${img}`)).then(() => {
                    index++
                    if (index == len) {
                        if (isApp.value) {
                            _this.proxy.$common.getUser((res: any) => {
                                res && $store.commit('SET_USERINFO', res)
                            })
                        }
                        $store.commit('SET_ACTIVITYDATA', data)
                        // 判断活动状态
                        activityStatus(data)
                    }
                })
            }
        }

        getActDetail()

        watch(() => router.currentRoute.value, (to, from) => {
            if (to.fullPath != from.fullPath) {
                $store.commit('SET_DIALOGDATA', null)
                _this.proxy.$common.pageLoading()
                document.documentElement.scrollTop = 0
            }
        })

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            if(isApp.value) {
                document.documentElement.className = 'webview-app'
            }
            window.addEventListener('pageshow', (e) => {
                if (e.persisted) {
                    window.location.reload()
                }
            })
            _this.proxy.$common.rootRem(false, .5625)
            window.addEventListener('resize', () => {
                _this.proxy.$common.rootRem(false, .5625) 
            })
        })

        return {
            musicUrl
        }
    }
})

